module.exports = __webpack_public_path__ + "img/encontre_numero_cartao_chip.bdcc6e6c.jpg";